export const RoleAssignmentType = {
  VIA_ID: 'ViaId',
  VIA_NAME: 'ViaName',
};
